import React, { Component } from "react";
import { Table, Button, Row, Col, Tooltip } from "antd";
import axios from "axios";
import PrintModalSemCab from '../components/PrintModalSemCab';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";
import { getUsuario } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import { maskCNPJ, maskCPF } from "../utils/Masker";
import { resolveImageUrl } from '../utils/Storage';

const { Column } = Table;

class OrcamentoReduzidaPrintModal extends Component {
    state = {
        registro: [],
        orc_idf: 0,
        listaProdutos: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        // console.log('OrcamentoReduzidaPrintModal - componentDidUpdate - this.props: ', this.props);
        // console.log('OrcamentoReduzidaPrintModal - componentDidUpdate - propsAnte: ', propsAnte);
        if ((this.props.visivel !== propsAnte.visivel) && (this.props.orc_idf)) {
            // console.log('OrcamentoReduzidaPrintModal - componentDidUpdate - 2222222');
            this.setState({
                orc_idf: this.props.orc_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { orc_idf } = this.props;

        axios
            .get(`/orcamentos/show/${orc_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('getListaRegistros: ', data);

                let listaProdutos = [];
                let vlr_prod = 0;
                let vlr_serv = 0;
                let vlr_avul = 0;
                let vlr_total = 0;

                for (var x in data.listaProdutos) {

                    if (data.listaProdutos[x].oi_item) {
                        vlr_prod = vlr_prod + parseFloat(data.listaProdutos[x].oi_vlr_total);

                        listaProdutos.push({
                            ven_idf: 0,
                            venc_idf: 0,
                            mi_idf_condicional: 0,
                            mi_item: data.listaProdutos[x].oi_item,
                            mi_servico: { key: '0' },
                            mi_item_Avulso: '',
                            mi_seq: listaProdutos.length + 1,
                            prod_idf: data.listaProdutos[x].prod_idf,
                            pest_qtde: data.listaProdutos[x].oi_qtde,
                            prod_grade: 0,
                            mi_item_tamanho: 0,
                            mi_item_cor: 0,
                            ptam_descricao: '',
                            pcor_descricao: '',
                            prod_codigo: data.listaProdutos[x].prod_codigo,
                            prod_descricao: data.listaProdutos[x].prod_descricao,
                            prod_cod_barras: data.listaProdutos[x].prod_cod_barras,
                            mi_qtde: parseFloat(data.listaProdutos[x].oi_qtde),
                            osia_custo_unit: 0,
                            mi_vlr_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_venda: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_venda_min: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_perc_desc: 0,
                            mi_vlr_desc: parseFloat(data.listaProdutos[x].oi_vlr_desc),
                            mi_vlr_acres: parseFloat(data.listaProdutos[x].oi_vlr_acresc),
                            mi_vlr_total: parseFloat(data.listaProdutos[x].oi_vlr_total),
                            mi_calc_estoque: parseFloat(data.listaProdutos[x].prod_controla_estoque),
                            tipoItem: 'P',
                        });

                    } else if (data.listaProdutos[x].oi_servico) {
                        vlr_serv = vlr_serv + parseFloat(data.listaProdutos[x].oi_vlr_total);

                        listaProdutos.push({
                            ven_idf: 0,
                            venc_idf: 0,
                            mi_idf_condicional: 0,
                            mi_item: { key: '0' },
                            mi_servico: data.listaProdutos[x].oi_servico,
                            mi_item_Avulso: '',
                            mi_seq: listaProdutos.length + 1,
                            prod_idf: '',
                            pest_qtde: 0,
                            prod_grade: '',
                            mi_item_tamanho: '',
                            mi_item_cor: '',
                            ptam_descricao: '',
                            pcor_descricao: '',
                            prod_codigo: '',
                            prod_descricao: data.listaProdutos[x].serv_descricao,
                            prod_cod_barras: '',
                            mi_qtde: parseFloat(data.listaProdutos[x].oi_qtde),
                            osia_custo_unit: 0,
                            mi_vlr_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_venda: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_venda_min: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_perc_desc: 0,
                            mi_vlr_desc: 0,
                            mi_vlr_acres: 0,
                            mi_vlr_total: parseFloat(data.listaProdutos[x].oi_vlr_total),
                            mi_calc_estoque: 0,
                            tipoItem: 'S',
                        });

                    } else {
                        vlr_avul = vlr_avul + parseFloat(data.listaProdutos[x].oi_vlr_total);

                        listaProdutos.push({
                            ven_idf: 0,
                            venc_idf: 0,
                            mi_idf_condicional: 0,
                            mi_item: { key: '0' },
                            mi_servico: 0,
                            mi_item_Avulso: data.listaProdutos[x].oi_item_avulo,
                            mi_seq: listaProdutos.length + 1,
                            prod_idf: '',
                            pest_qtde: 0,
                            prod_grade: '',
                            mi_item_tamanho: '',
                            mi_item_cor: '',
                            ptam_descricao: '',
                            pcor_descricao: '',
                            prod_codigo: '',
                            prod_descricao: data.listaProdutos[x].oi_item_avulo,
                            prod_cod_barras: '',
                            mi_qtde: parseFloat(data.listaProdutos[x].oi_qtde),
                            osia_custo_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_unit: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_venda: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_vlr_venda_min: parseFloat(data.listaProdutos[x].oi_vlr_unit),
                            mi_perc_desc: 0,
                            mi_vlr_desc: 0,
                            mi_vlr_acres: 0,
                            mi_vlr_total: parseFloat(data.listaProdutos[x].oi_vlr_total),
                            mi_calc_estoque: 0,
                            tipoItem: 'A',
                        });

                    }

                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: listaProdutos,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            ven_idf: 0,
            registro: [],
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderTipoItem = (tipo) => {
        return (
            <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
        );
    };

    renderDescrProduto = (prod_descricao, registro) => {
        return (
            <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }





    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos } = this.state;
        const { orc_numero, orc_data_emissao, ven_pessoa, pes_codigo, pes_nome, usu_nome,
            pes_fone1, pes_fone2, pes_fone3,
            orc_descricao, orc_nome_cliente, orc_fone, orc_endereco, orc_atividade, orc_obs, cp_descricao } = this.state.registro;

        const usuario = getUsuario();

        // console.log('OrcamentoReduzidaPrintModal: ', this.state);

        return (
            <span style={{}}>
                <PrintModalSemCab
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                >

                    <Row className="bordaExternaOS2Vias">
                        <Row className="bordaInternaOS2Vias">
                            {usuario.emp_logo ? (
                                <div style={{ float: "right", margin: 5 }}>
                                    <img
                                        src={usuario.emp_logo ? resolveImageUrl(`imagens/emp${usuario.emp_codigo}.${usuario.emp_logo}`) : ''}
                                        resizeMode="contain"
                                        style={{ height: 60, width: 60 }}
                                    />
                                </div>
                            ) : null}

                            <div style={{ float: "left", margin: 5 }}>
                                <div>
                                    <span className="nome-empresa">
                                        {usuario.emp_nome}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {!usuario.emp_cpf_cnpj ? '' : usuario.emp_cpf_cnpj.length === 11 ? maskCPF(usuario.emp_cpf_cnpj) : maskCNPJ(usuario.emp_cpf_cnpj)}
                                        {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                        {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                        {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                        {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                        {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                        {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                        {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                        {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                    </span>
                                </div>
                            </div>
                        </Row>

                        <Row className="bordaInternaOS2Vias">
                            <Col xs={12}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey", marginLeft: 10 }}>ORÇAMENTO</span>
                            </Col>
                            <Col xs={4}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey" }}>Nº: </span>
                                <span style={{ textAlign: "center", fontSize: 20, color: "grey" }}> {orc_numero} </span>
                            </Col>
                            <Col xs={8} style={{ paddingTop: 5 }}>
                                <span style={{ textAlign: "center", fontSize: 15, fontWeight: "bold", color: "grey" }}>Emissão: </span>
                                <span style={{ textAlign: "center", fontSize: 15, color: "grey" }}> {this.renderData(orc_data_emissao)} </span>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 140 }}>
                            <Col xs={12}>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Cliente:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_nome_cliente ? orc_nome_cliente : pes_codigo + ' - ' + pes_nome}</span>
                                    {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                        <span>
                                            {orc_fone ? orc_fone :
                                                (<span>
                                                    <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                                    <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                                    <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                                </span>)}
                                        </span>
                                    ) : null}
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Descrição:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_descricao}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Vendedor:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{usu_nome}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Pagto:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{cp_descricao}</span>
                                </div>
                                {/* <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>OBS:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_atividade}</span>
                                </div> */}
                            </Col>
                            <Col xs={12}>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Atividade:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_atividade}</span>
                                    </div>
                                </div>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>OBS:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_obs}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 200 }}>
                            <Table
                                pagination={false}
                                dataSource={listaProdutos}
                                // className="tabela"
                                rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tipoItem"
                                    dataIndex="tipoItem"
                                    title="Tipo Item"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                    render={this.renderTipoItem}
                                />
                                <Column
                                    key="prod_codigo"
                                    dataIndex="prod_codigo"
                                    title="Código"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="prod_descricao"
                                    dataIndex="prod_descricao"
                                    title="Descrição"
                                    width={200}
                                    align="left"
                                    className="listaCadastro"
                                    render={this.renderDescrProduto}
                                />
                                <Column
                                    key="mi_qtde"
                                    dataIndex="mi_qtde"
                                    title="Qtde"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_unit"
                                    dataIndex="mi_vlr_unit"
                                    title="Vlr Unit"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_desc"
                                    dataIndex="mi_vlr_desc"
                                    title="Vlr Desc"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_total"
                                    dataIndex="mi_vlr_total"
                                    title="Vlr Total"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>

                        <Row style={{ marginTop: 10, marginBottom: 0 }}>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Responsável</span>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Cliente</span>
                                </div>
                            </Col>
                        </Row>
                    </Row>








                    <Row className="bordaExternaOS2Vias" style={{ marginTop: 30 }}>
                        <Row className="bordaInternaOS2Vias">
                            {usuario.emp_logo ? (
                                <div style={{ float: "right", margin: 5 }}>
                                    <img
                                        src={usuario.emp_logo ? resolveImageUrl(`imagens/emp${usuario.emp_codigo}.${usuario.emp_logo}`) : ''}
                                        resizeMode="contain"
                                        style={{ height: 60, width: 60 }}
                                    />
                                </div>
                            ) : null}

                            <div style={{ float: "left", margin: 5 }}>
                                <div>
                                    <span className="nome-empresa">
                                        {usuario.emp_nome}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {!usuario.emp_cpf_cnpj ? '' : usuario.emp_cpf_cnpj.length === 11 ? maskCPF(usuario.emp_cpf_cnpj) : maskCNPJ(usuario.emp_cpf_cnpj)}
                                        {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                        {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                        {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                        {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                        {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                        {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                        {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                        {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                    </span>
                                </div>
                            </div>
                        </Row>

                        <Row className="bordaInternaOS2Vias">
                            <Col xs={12}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey", marginLeft: 10 }}>ORÇAMENTO</span>
                            </Col>
                            <Col xs={4}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey" }}>Nº: </span>
                                <span style={{ textAlign: "center", fontSize: 20, color: "grey" }}> {orc_numero} </span>
                            </Col>
                            <Col xs={8} style={{ paddingTop: 5 }}>
                                <span style={{ textAlign: "center", fontSize: 15, fontWeight: "bold", color: "grey" }}>Emissão: </span>
                                <span style={{ textAlign: "center", fontSize: 15, color: "grey" }}> {this.renderData(orc_data_emissao)} </span>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 140 }}>
                            <Col xs={12}>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Cliente:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_nome_cliente ? orc_nome_cliente : pes_codigo + ' - ' + pes_nome}</span>
                                    {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                        <span>
                                            <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                            <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                            <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                        </span>
                                    ) : null}
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Descrição:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_descricao}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Vendedor:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{usu_nome}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Pagto:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{cp_descricao}</span>
                                </div>
                                {/* <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>CheckList:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_obs}</span>
                                </div> */}
                            </Col>
                            <Col xs={12}>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Atividade:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_atividade}</span>
                                    </div>
                                </div>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>OBS:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{orc_obs}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 200 }}>
                            <Table
                                pagination={false}
                                dataSource={listaProdutos}
                                // className="tabela"
                                rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tipoItem"
                                    dataIndex="tipoItem"
                                    title="Tipo Item"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                    render={this.renderTipoItem}
                                />
                                <Column
                                    key="prod_codigo"
                                    dataIndex="prod_codigo"
                                    title="Código"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="prod_descricao"
                                    dataIndex="prod_descricao"
                                    title="Descrição"
                                    width={200}
                                    align="left"
                                    className="listaCadastro"
                                    render={this.renderDescrProduto}
                                />
                                <Column
                                    key="mi_qtde"
                                    dataIndex="mi_qtde"
                                    title="Qtde"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_unit"
                                    dataIndex="mi_vlr_unit"
                                    title="Vlr Unit"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_desc"
                                    dataIndex="mi_vlr_desc"
                                    title="Vlr Desc"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_total"
                                    dataIndex="mi_vlr_total"
                                    title="Vlr Total"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>

                        <Row style={{ marginTop: 10, marginBottom: 0 }}>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Responsável</span>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Cliente</span>
                                </div>
                            </Col>
                        </Row>
                    
                    </Row>




                </PrintModalSemCab>
            </span >
        );
    }
}

export default OrcamentoReduzidaPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/OrcamentoReduzidaPrintModal.js